<div class="container-fluid">
  <div class="jumbotron test-center">
    <h1>
      <div class="text-center">You've been logged out</div>
    </h1>
  </div>
</div>
